import { KYMW0C00Model } from '../kymw0c00.model';
import { PlessResponderSub } from '../../../../commons/kymw00/pless-responder-sub.service';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 画像作成指示画面　サンプル発注書・撮影指示書を取得するサービス
 *
 * @export GetSampleOrderingOutputService
 * @class GetSampleOrderingOutputService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetSampleOrderingOutputService extends PlessJsonResponderSub<any> {

  private imageGroupArray: Array<string>;

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW0C00Model}
   * @memberof GetSampleOrderingOutputService
   */
  private model: KYMW0C00Model;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetSampleOrderingOutputService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetSampleOrderingOutputService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        ImageGroupNoList: {
          combination: this.imageGroupArray.map(ImageGroupNo => {
            return {
              parameter: {
                ImageGroupNO: ImageGroupNo
              }
            }
          })
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetSampleOrderingOutputService
   */
  execute(model: any, imageGroupArray: Array<string>, successFunc: Function): void {
    this.model = <KYMW0C00Model>model;
    this.imageGroupArray = imageGroupArray;
    this.successFunc = successFunc;
    this.send('KYMW17GetSampleOrderingOutput', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetSampleOrderingOutputService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
